import React from 'react'
import { Column } from 'primereact/column'
import { useIntl } from 'react-intl'
import DataTableComp from '../../common/data-table/DataTableComp'
import DeleteButton from '../../common/buttons/DeleteButton'
import auxFunction from '../../../utils/helpers/auxFun'
import { bodyCurrencyInput } from '../../common/data-table/column-types/ColumnTypes'

const FulesPriceTable = ({
  prices,
  showChangeDate = false,
  withfuelStation,
  handleDelete,
}) => {
  const { formatMessage: msg } = useIntl()

  const buttonDelete = (rowData) => {
    return (
      <div key={Math.random()}>
        <DeleteButton onClick={() => handleDelete(rowData)} />
      </div>
    )
  }

  return (
    <DataTableComp
      disableAutoheight
      tableOptions={{
        value: prices,
        size: 'small',
      }}
      columns={[
        withfuelStation && (
          <Column
            field="ownStation.centerName"
            header={msg({ id: 'center' })}
          />
        ),
        showChangeDate && (
          <Column
            field="changeDate"
            header={msg({ id: 'change.date' })}
            body={(rowData) =>
              auxFunction.parseDateAndHour(rowData?.changeDate)
            }
          />
        ),
        <Column
          field="prices.GOA"
          header="GOA"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.GOA)}
        />,
        <Column
          field="prices.GOAPLUS"
          header="GOAPLUS"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.GOAPLUS)}
        />,
        <Column
          field="prices.G95"
          header="G95"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.G95)}
        />,
        <Column
          field="prices.AdBlue"
          header="AdBlue"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.AdBlue)}
        />,
        handleDelete && (
          <Column
            body={(rowData) => buttonDelete(rowData)}
            exportable={false}
          />
        ),
      ]}
    />
  )
}

export default FulesPriceTable
